// extracted by mini-css-extract-plugin
export default {"loading-wrapper":"Reporting_loading-wrapper__g-k-f","sortDropdownWrapper":"Reporting_sortDropdownWrapper__Rjbwh"};